export default __webpack_public_path__ + "static/media/exisiting-icon.6025078f.svg";